import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=62c7332d&scoped=true"
import script from "./Admin.js?vue&type=script&lang=js&external"
export * from "./Admin.js?vue&type=script&lang=js&external"
import style0 from "./Admin.scss?vue&type=style&index=0&id=62c7332d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c7332d",
  null
  
)

export default component.exports